import cls from './Experience.module.scss';
import { useTranslation } from "react-i18next";

function Experience() {
    const { t } = useTranslation();

    const experiences = [
        {
            title: t('expProjectsTitle'),
            period: t('expProjectsPeriod'),
            description: t('expProjectsDesc'),
            achievements: [
                t('expProjectsAchiev1'),
                t('expProjectsAchiev2'),
                t('expProjectsAchiev3')
            ],
            stack: t('expProjectsStack')
        },
        {
            title: t('expSoulTitle'),
            period: t('expSoulPeriod'),
            description: t('expSoulDesc'),
            achievements: [t('expSoulAchiev')],
            stack: t('expSoulStack')
        },
        {
            title: t('expAiTitle'),
            period: t('expAiPeriod'),
            description: t('expAiDesc'),
            achievements: [t('expAiAchiev1'), t('expAiAchiev2')],
            stack: t('expAiStack')
        },
        {
            title: t('expMosaicTitle'),
            period: t('expMosaicPeriod'),
            description: t('expMosaicDesc'),
            stack: t('expMosaicStack')
        }
    ];

    return (
        <section className={cls.experience}>
            <h2 className={cls.title}>{t('Experience')}</h2>
            <div className={cls.list}>
                {experiences.map((exp, index) => (
                    <div className={cls.item} key={index}>
                        <div className={cls.header}>
                            <h3 className={cls.jobTitle}>{exp.title}</h3>
                            {exp.period && <span className={cls.period}>{exp.period}</span>}
                        </div>
                        <p className={cls.description}>{exp.description}</p>
                        {exp.achievements && (
                            <ul className={cls.achievements}>
                                {exp.achievements.map((ach, i) => (
                                    <li key={i}>{ach}</li>
                                ))}
                            </ul>
                        )}
                        <p className={cls.stack}>{exp.stack}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Experience;
